import api from './api';

const projectService = {
  /**
   * Get all projects for the current organization
   */
  async getAll() {
    const response = await api.get('/projects');
    return response.data;
  },

  /**
   * Get a single project by ID
   */
  async getById(id) {
    const response = await api.get(`/projects/${id}`);
    return response.data;
  },

  /**
   * Create a new project
   */
  async create(projectData) {
    // Map frontend form data to API expected format
    const payload = {
      name: projectData.name,
      code: projectData.code,
      description: projectData.description,
      projectStage: projectData.projectStage,
      projectType: projectData.projectType,
      projectTypeOther: projectData.projectTypeOther,
      location: projectData.location,
      latitude: projectData.latitude ? parseFloat(projectData.latitude) : null,
      longitude: projectData.longitude ? parseFloat(projectData.longitude) : null,
      countryCode: projectData.country, // frontend uses 'country', backend expects 'countryCode'
      startDate: projectData.startDate || null,
      endDate: projectData.endDate || null,
      contractor: projectData.contractor,
      projectManager: projectData.projectManager,
      trackingCategories: projectData.trackingCategories,
      customCategories: projectData.customCategories,
      numberOfWorkers: projectData.numberOfWorkers === '' || projectData.numberOfWorkers === undefined || projectData.numberOfWorkers === null
        ? null : Number(projectData.numberOfWorkers),
      locations: projectData.locations || [],
    };

    const response = await api.post('/projects', payload);
    return response.data;
  },

  /**
   * Update an existing project
   */
  async update(id, projectData) {
    const response = await api.patch(`/projects/${id}`, projectData);
    return response.data;
  },

  /**
   * Delete a project
   */
  async delete(id) {
    const response = await api.delete(`/projects/${id}`);
    return response.data;
  },
};

export default projectService;
